// eslint-disable-next-line no-unused-vars
import { Component } from 'react';
import PropTypes from 'prop-types';
import { updateURLWithActiveVersion } from '%/utils/urlHandler';

export default class ShowcaseNewVehiclesFiatV2Carousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startPosition: 0,
      carousel: null,
    };

    this.initCarousel = this.initCarousel.bind(this);
    this.setActiveVersionInStore = this.setActiveVersionInStore.bind(this);
    this.handleCarouselChange = this.handleCarouselChange.bind(this);
    this.handleVersionChange = this.handleVersionChange.bind(this);
  }

  componentDidMount() {
    const { defaultVersionSlug, versions } = this.props;

    this.setStartPosition(defaultVersionSlug);
    this.initCarousel();
    this.setVersionsInGlobalScope(versions);
    this.handleVersionChange(defaultVersionSlug, false);
    this.watchStoredVersion();
  }

  handleCarouselChange(carousel, currentIndex) {
    const slides = carousel.Components.Elements.slides;
    const activeSlide = slides[currentIndex];
    const versionSlug = activeSlide.dataset.slug;

    this.handleVersionChange(versionSlug);
  }

  handleVersionChange(versionSlug, urlUpdate = true) {
    const activeVersion = this.findVersionBySlug(versionSlug);

    this.setActiveVersionInStore(activeVersion);

    if (urlUpdate) {
      updateURLWithActiveVersion(versionSlug);
    }
  }

  setStartPosition(defaultVersionSlug) {
    const versionId = this.findVersionIdBySlug(defaultVersionSlug);
    const startPosition = versionId > 0 ? versionId : 0;

    this.setState({ startPosition });
  }

  setVersionsInGlobalScope(versions) {
    window.versions = JSON.stringify(versions);
  }

  setActiveVersionInStore(versionData) {
    window.store.vehicleVersionDetails.setState({
      activeVersion: versionData,
    });
  }

  watchStoredVersion() {
    window.store.vehicleVersionDetails.watch(state => {
      const { carousel } = this.state;
      const indexCarousel = carousel.index;
      const activeVersionId = this.findVersionIdBySlug(
        state.activeVersion.slug,
      );

      if (activeVersionId !== indexCarousel) {
        carousel.go(activeVersionId);
      }
    });
  }

  findVersionBySlug(slug) {
    return this.props.versions.find(version => version.slug === slug);
  }

  findVersionIdBySlug(slug) {
    return this.props.versions.findIndex(version => version.slug === slug);
  }

  initCarousel() {
    const { startPosition } = this.state;

    const carousel = window.makeCarousel(this.carouselRef, {
      start: startPosition,
      perPage: 1,
      focus: 'center',
      gap: '-48%',
      lazyLoad: 'nearby',
      preloadPages: 0,
      breakpoints: {
        576: {
          perPage: 1,
          padding: 0,
        },
        992: {
          gap: 0,
        },
        1300: {
          gap: '-40%',
        },
      },
    });

    carousel.on('move', newIndex => {
      this.handleCarouselChange(carousel, newIndex);
    });

    this.setState({ carousel });
  }

  render() {
    const { versions } = this.props;

    return (
      <div
        className="showcase-new-cars__carousel splide"
        data-single-version={versions.length === 1}
        ref={node => {
          this.carouselRef = node;
        }}
      >
        <div className="splide__arrows">
          <button type="button" className="splide__arrow splide__arrow--prev">
            <i className="icon icon-arrow-left" />
          </button>
          <button type="button" className="splide__arrow splide__arrow--next">
            <i className="icon icon-arrow-right" />
          </button>
        </div>

        <div className="splide__track">
          <div className="splide__list showcase-new-cars__carousel-items-wrapper">
            {versions.length > 0 &&
              versions.map((version, index) => {
                const isInitial = index === 0;

                const sourceProps = isInitial
                  ? { srcSet: version.item_image.middle_image }
                  : {
                      'data-splide-lazy-srcset':
                        version.item_image.middle_image,
                    };

                const imgProps = isInitial
                  ? { src: version.item_image.main_image }
                  : { 'data-splide-lazy': version.item_image.main_image };

                return (
                  <div
                    key={version.slug}
                    className="showcase-new-cars__carousel-item splide__slide"
                    data-slug={version.slug}
                  >
                    <picture>
                      <source media="(max-width: 576px)" {...sourceProps} />
                      <img
                        className="showcase-new-cars__carousel-item-image"
                        alt={`Imagem do ${version.model || version.name}`}
                        width="700"
                        height="491.1"
                        {...imgProps}
                      />
                    </picture>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseNewVehiclesFiatV2Carousel.defaultProps = {
  versions: [],
  defaultVersionSlug: '',
};

ShowcaseNewVehiclesFiatV2Carousel.propTypes = {
  versions: PropTypes.arrayOf(
    PropTypes.shape({
      model: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  defaultVersionSlug: PropTypes.string,
};
